// extracted by mini-css-extract-plugin
export default {"root":"NumberRangeFilterPlain_root__r9BtC marketplaceTinyFontStyles"};